/**
 * Wrap all strings from translation map with ⟦  ⟧
 * */
export function mapTestKeys(obj) {
  const testObj = {};

  Object.keys(obj).forEach((key) => {
    if (typeof obj[key] === 'string') {
      testObj[key] = `⟦${obj[key]}⟧`;
    } else {
      testObj[key] = mapTestKeys(obj[key]);
    }
  });

  return testObj;
}

const RealDate = Date;

export function mockDate(date) {
  global.Date = vi.fn((...props) => (props.length ? new RealDate(...props) : new RealDate(date)));
  global.Date.UTC = RealDate.UTC;
  Object.assign(Date, RealDate);
}

export function resetDate() {
  global.Date = RealDate;
}
